import { Box, Switch, Typography } from "@mui/material";
import React from "react";
import ClientsDatagridView from "./ClientsDatagridView";
import ClientsMapView from "./ClientsMapView";

const Clients = () => {
  const [checked, setChecked] = React.useState(true);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Map View</Typography>
        <Switch
          sx={{
            "& .MuiSwitch-track": { bgcolor: "info.main" },
            "& .Mui-checked .MuiSwitch-thumb": { bgcolor: "primary.main" },
            "&  .MuiSwitch-thumb": { bgcolor: "info.main" },
          }}
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
        <Typography variant="h6">Grid View</Typography>
      </Box>
      <br />
      {checked ? <ClientsDatagridView /> : <ClientsMapView />}
    </div>
  );
};

export default Clients;
